import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './portfolio-layout.css';

export default function PortfolioLayout({ children }) {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        // Trigger loading state on route change
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 100);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
        <div className="portfolio-layout">
            <div className={`portfolio-container ${isLoading ? 'loading' : 'loaded'}`}>
                {children}
            </div>
        </div>
    );
}
